export default __webpack_public_path__ + "static/media/ireland.4abbd8aa.svg";